import React, { Component } from "react";
import { EditorLayout } from "../../contents";
import RaisedButton from "material-ui/RaisedButton";
import { Flex } from "rebass";
const defaultContent = {
  "4utj": {
    id: "4utj",
    type: "Content",
    props: {
      values: {
        type: "Content",
        column: 2,
        parent: "Row",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        className: "col-xs-12 col-lg-6 col-md-6",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          urlMobile: ""
        },
        isBackgroundImage: false
      }
    },
    parent: {
      id: "7l1ap",
      idx: 1
    },
    childOf: "Row",
    children: ["co92e"]
  },
  enrs: {
    id: "enrs",
    type: "ProductListView",
    props: {
      values: {
        list: [43],
        type: "ProductListView",
        parent: "Content",
        showPrice: true,
        containerPadding: "0px"
      }
    },
    style: {},
    parent: {
      id: "6mdgr",
      idx: 0
    },
    childOf: "Content",
    children: []
  },
  root: {
    id: "root",
    type: "Body",
    props: {
      values: {
        width: {
          type: "px",
          contentWidth: 1280
        },
        fullheight: true,
        contentWidth: "1280px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        backgroundImage: {
          url: ""
        }
      }
    },
    children: ["7l1ap", "eol1u", "8biag"]
  },
  tbms: {
    id: "tbms",
    type: "ImageView",
    props: {
      values: {
        href: {
          url: "",
          target: "",
          collection: 0,
          isCollection: false
        },
        type: "ImageView",
        align: "center",
        width: "100%",
        action: {
          url: "",
          target: ""
        },
        parent: "Content",
        altText: "Image one",
        imageUrl: {
          url:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-APG.png",
          mobile: {
            width: 0,
            height: 0
          },
          desktop: {
            width: 960,
            height: 473
          },
          urlMobile: ""
        },
        animation: {
          show: false,
          type: "ease both",
          duration: 1000,
          direction: "fade"
        },
        containerPadding: "0px"
      }
    },
    style: {},
    parent: {
      id: "14nri",
      idx: 0
    },
    childOf: "Content",
    children: []
  },
  "14nri": {
    id: "14nri",
    type: "Content",
    props: {
      values: {
        type: "Content",
        width: {
          type: "%",
          contentWidth: 100
        },
        column: 2,
        parent: "Row",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        alignment: {
          vertical: "center",
          horizontal: "center"
        },
        className: "col-xs-12 col-lg-6 col-md-6",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          mobile: {
            width: 0,
            height: 0
          },
          desktop: {
            width: 0,
            height: 0
          },
          urlMobile: ""
        },
        isBackgroundImage: false,
        backgroundColorParent: "rgba(255,255,255,0)"
      }
    },
    parent: {
      id: "eol1u",
      idx: 1
    },
    childOf: "Row",
    children: ["tbms"]
  },
  "183kj": {
    id: "183kj",
    type: "ImageTextView",
    props: {
      values: {
        text: {
          value:
            '<h2 class="ql-align-center"><span style="color: rgb(255, 255, 255);">[KOLNAME]</span></h2><p class="ql-align-center"><span style="color: rgb(255, 255, 255);">ola.id/[nickname]</span></p>',
          lineHeight: "140%",
          letterSpacing: "5px",
          backgroundColor: "rgba(255,255,255,0)",
          containerPadding: "0px"
        },
        type: "ImageTextView",
        parent: "Content",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageTextView-image-desktop-XPS.jpeg",
          urlMobile:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageTextView-image-mobile-HMI.jpeg"
        },
        containerPadding: "0px"
      }
    },
    style: {},
    parent: {
      id: "3q7pb",
      idx: 0
    },
    childOf: "Content",
    children: []
  },
  "3q7pb": {
    id: "3q7pb",
    type: "Content",
    props: {
      values: {
        type: "Content",
        column: 2,
        parent: "Row",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        className: "col-xs-12 col-lg-6 col-md-6",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          urlMobile: ""
        },
        isBackgroundImage: false
      }
    },
    parent: {
      id: "7l1ap",
      idx: 0
    },
    childOf: "Row",
    children: ["183kj"]
  },
  "6mdgr": {
    id: "6mdgr",
    type: "Content",
    props: {
      values: {
        type: "Content",
        width: {
          type: "%",
          contentWidth: 100
        },
        column: 1,
        parent: "Row",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        alignment: {
          vertical: "center",
          horizontal: "center"
        },
        className: "col-xs-12",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          mobile: {
            width: 0,
            height: 0
          },
          desktop: {
            width: 0,
            height: 0
          },
          urlMobile: ""
        },
        isBackgroundImage: false,
        backgroundColorParent: "rgba(255,255,255,0)"
      }
    },
    parent: {
      id: "8biag",
      idx: 0
    },
    childOf: "Row",
    children: ["enrs"]
  },
  "7l1ap": {
    id: "7l1ap",
    type: "Row2",
    props: {
      values: {
        type: "Row",
        align: "center",
        width: {
          type: "%",
          contentWidth: 100
        },
        parent: "Body",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          urlMobile: ""
        },
        isBackgroundImage: false
      },
      content: [
        {
          type: "Content",
          props: {
            values: {
              type: "Content",
              column: 2,
              parent: "Row",
              bgProps: {
                size: "cover",
                ratio: 1.2,
                repeat: "no-repeat",
                position: "center"
              },
              padding: "0px",
              className: "col-xs-12 col-lg-6 col-md-6",
              backgroundColor: "rgba(255,255,255,0)",
              backgroundImage: {
                url: "",
                urlMobile: ""
              },
              isBackgroundImage: false
            }
          },
          childOf: "Row",
          children: []
        },
        {
          type: "Content",
          props: {
            values: {
              type: "Content",
              column: 2,
              parent: "Row",
              bgProps: {
                size: "cover",
                ratio: 1.2,
                repeat: "no-repeat",
                position: "center"
              },
              padding: "0px",
              className: "col-xs-12 col-lg-6 col-md-6",
              backgroundColor: "rgba(255,255,255,0)",
              backgroundImage: {
                url: "",
                urlMobile: ""
              },
              isBackgroundImage: false
            }
          },
          childOf: "Row",
          children: []
        }
      ]
    },
    style: {},
    parent: {
      id: "root",
      idx: 0
    },
    childOf: "Body",
    children: ["3q7pb", "4utj"]
  },
  "8biag": {
    id: "8biag",
    type: "Row1",
    props: {
      values: {
        name: "Row1",
        type: "Row",
        align: "center",
        width: {
          type: "%",
          contentWidth: 100
        },
        parent: "Body",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          urlMobile: ""
        },
        isBackgroundImage: false
      },
      content: [
        {
          type: "Content",
          props: {
            values: {
              type: "Content",
              width: {
                type: "%",
                contentWidth: 100
              },
              column: 1,
              parent: "Row",
              bgProps: {
                size: "cover",
                ratio: 1.2,
                repeat: "no-repeat",
                position: "center"
              },
              padding: "0px",
              alignment: {
                vertical: "center",
                horizontal: "center"
              },
              className: "col-xs-12",
              backgroundColor: "rgba(255,255,255,0)",
              backgroundImage: {
                url: "",
                mobile: {
                  width: 0,
                  height: 0
                },
                desktop: {
                  width: 0,
                  height: 0
                },
                urlMobile: ""
              },
              isBackgroundImage: false,
              backgroundColorParent: "rgba(255,255,255,0)"
            }
          },
          childOf: "Row",
          children: []
        }
      ]
    },
    style: {},
    parent: {
      id: "root",
      idx: 2
    },
    childOf: "Body",
    children: ["6mdgr"]
  },
  a7ldk: {
    id: "a7ldk",
    type: "Content",
    props: {
      values: {
        type: "Content",
        width: {
          type: "%",
          contentWidth: 100
        },
        column: 2,
        parent: "Row",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        alignment: {
          vertical: "center",
          horizontal: "center"
        },
        className: "col-xs-12 col-lg-6 col-md-6",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          mobile: {
            width: 0,
            height: 0
          },
          desktop: {
            width: 0,
            height: 0
          },
          urlMobile: ""
        },
        isBackgroundImage: false,
        backgroundColorParent: "rgba(255,255,255,0)"
      }
    },
    parent: {
      id: "eol1u",
      idx: 1
    },
    childOf: "Row",
    children: ["fbi3s"]
  },
  co92e: {
    id: "co92e",
    type: "ImageView",
    props: {
      values: {
        href: {
          url: "",
          target: "",
          collection: 0,
          isCollection: false
        },
        type: "ImageView",
        align: "center",
        width: "100%",
        action: {
          url: "",
          target: ""
        },
        parent: "Content",
        altText: "Image one",
        imageUrl: {
          url:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-IML.jpeg",
          urlMobile:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-M3I.jpeg"
        },
        animation: {
          show: false,
          type: "ease both",
          duration: 1000,
          direction: "fade"
        },
        containerPadding: "0px"
      }
    },
    style: {},
    parent: {
      id: "4utj",
      idx: 0
    },
    childOf: "Content",
    children: []
  },
  eol1u: {
    id: "eol1u",
    type: "Row2",
    props: {
      values: {
        name: "Row2",
        type: "Row",
        align: "center",
        width: {
          type: "%",
          contentWidth: 100
        },
        parent: "Body",
        bgProps: {
          size: "cover",
          ratio: 1.2,
          repeat: "no-repeat",
          position: "center"
        },
        padding: "0px",
        backgroundColor: "rgba(255,255,255,0)",
        backgroundImage: {
          url: "",
          urlMobile: ""
        },
        isBackgroundImage: false
      },
      content: [
        {
          type: "Content",
          props: {
            values: {
              type: "Content",
              width: {
                type: "%",
                contentWidth: 100
              },
              column: 2,
              parent: "Row",
              bgProps: {
                size: "cover",
                ratio: 1.2,
                repeat: "no-repeat",
                position: "center"
              },
              padding: "0px",
              alignment: {
                vertical: "center",
                horizontal: "center"
              },
              className: "col-xs-12 col-lg-6 col-md-6",
              backgroundColor: "rgba(255,255,255,0)",
              backgroundImage: {
                url: "",
                mobile: {
                  width: 0,
                  height: 0
                },
                desktop: {
                  width: 0,
                  height: 0
                },
                urlMobile: ""
              },
              isBackgroundImage: false,
              backgroundColorParent: "rgba(255,255,255,0)"
            }
          },
          childOf: "Row",
          children: []
        },
        {
          type: "Content",
          props: {
            values: {
              type: "Content",
              width: {
                type: "%",
                contentWidth: 100
              },
              column: 2,
              parent: "Row",
              bgProps: {
                size: "cover",
                ratio: 1.2,
                repeat: "no-repeat",
                position: "center"
              },
              padding: "0px",
              alignment: {
                vertical: "center",
                horizontal: "center"
              },
              className: "col-xs-12 col-lg-6 col-md-6",
              backgroundColor: "rgba(255,255,255,0)",
              backgroundImage: {
                url: "",
                mobile: {
                  width: 0,
                  height: 0
                },
                desktop: {
                  width: 0,
                  height: 0
                },
                urlMobile: ""
              },
              isBackgroundImage: false,
              backgroundColorParent: "rgba(255,255,255,0)"
            }
          },
          childOf: "Row",
          children: []
        }
      ]
    },
    style: {},
    parent: {
      id: "root",
      idx: 1
    },
    childOf: "Body",
    children: ["14nri", "a7ldk"]
  },
  fbi3s: {
    id: "fbi3s",
    type: "YoutubeView",
    props: {
      values: {
        type: "YoutubeView",
        parent: "Content",
        videoId: "9JqfShVZTPk",
        fullwidth: true,
        alignValue: "center",
        containerPadding: "0px"
      }
    },
    style: {},
    parent: {
      id: "a7ldk",
      idx: 0
    },
    childOf: "Content",
    children: []
  }
};

class FormPage extends Component {
  constructor(props) {
    super(props);
    const marketerId = props.match.params.id || 0;
    const { content } = props.record;
    let data = undefined;
    if (!Array.isArray(content)) {
      data = content;
      if (data === null) {
        data = content;
      }
    }
    this.state = {
      layoutSelected: props.record.content || [],
      content: data,
      marketerId: marketerId
    };
  }

  convertJsonContent = value => {
    let olaContent = JSON.stringify(defaultContent).replace(
      "[KOLNAME]",
      `${value.first_name} ${value.last_name}`
    );
    let newContent = olaContent.replace("[nickname]", value.nickname);
    this.setState({
      fullname: `${value.first_name} ${value.last_name}`,
      nickname: value.nickname
    });
    return JSON.parse(newContent);
  };

  onChangeData = (data, dataRaw) => {
    this.props.updateContent(dataRaw);
    this.setState({ layoutSelected: dataRaw, content: data });
  };
  onResetPage = () => {
    this.setState({
      data: undefined,
      layoutSelected: []
    });
    this.editorpage.onResetPage();
    this.props.updateContent(null);
  };
  render() {
    const { tabIndex } = this.props;
    return (
      <div>
        <Flex p={[2]} justify={["flex-end"]}>
          <RaisedButton
            label="Reset Page"
            primary={true}
            onClick={this.onResetPage.bind(this)}
          />
        </Flex>

        <EditorLayout
          ref={ref => (this.editorpage = ref)}
          onChangeData={(data, dataRaw) => this.onChangeData(data, dataRaw)}
          data={this.state.content}
          isShow={tabIndex === 1}
          statusForm={"create"}
          typePage={"marketers"}
          marketerId={this.props.match.params.id}
        />
      </div>
    );
  }
}
//
export default FormPage;



// WEBPACK FOOTER //
// ./src/marketers/form/FormPage.js